export const PRODUCTS = {
  MONTHLY: process.env.GATSBY_STRIPE_MONTHLY_PRODUCT,
  SINGLE: process.env.GATSBY_STRIPE_ONE_TIME_PRODUCT,
}
